// @ts-nocheck
import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import LiveDemoApp from './LiveDemoApp';
import './LiveDemo.css';
import { useAdmissionsLeads } from '../context/AdmissionsLeadsContext';

const LEAD_PROPAGATION_DELAY_MS = 2000;

export default function LiveDemoPage() {
  const navigate = useNavigate();
  const { refreshLeads } = useAdmissionsLeads();

  const openDashboard = async () => {
    // Give the read model time to include the newly-created lead, then fetch once.
    await new Promise((resolve) => window.setTimeout(resolve, LEAD_PROPAGATION_DELAY_MS));
    await refreshLeads().catch(() => undefined);
    navigate('/admissions/v2');
  };

  return (
    <div className="live-demo-root">
      <LiveDemoApp onOpenDashboard={openDashboard} />
    </div>
  );
}
